export default {
  computed: {
    playerInviteAndEarnDomain() {
      return this.$store.state.player.playerInviteAndEarnDomain
    },
    formRule() {
      return {
        email: [
          v =>
            !v ||
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            this.tr(this.FRONTEND_ERROR_CODES.emailFormatInvalid)
        ],
        date_of_birth: [v => !!v || this.tr(this.FRONTEND_ERROR_CODES.birthDateIsRequired)],
        phone: [v => !!v || this.tr(this.FRONTEND_ERROR_CODES.phoneNumberIsRequired)],
        social_media_id: [v => !!v || this.tr(this.FRONTEND_ERROR_CODES.socialMediaIdIsRequired)],
        social_media_type: [v => !!v || this.tr(this.FRONTEND_ERROR_CODES.platformIsRequired)]
      }
    },
    platforms() {
      return [
        {
          val: null,
          text: this.tl('none')
        },
        {
          val: 1,
          text: 'Telegram'
        },
        {
          val: 2,
          text: 'Zalo ID'
        },
        {
          val: 3,
          text: 'Line'
        },
        {
          val: 4,
          text: 'Facebook'
        },
        {
          val: 5,
          text: 'Whatsapp'
        },
        {
          val: 6,
          text: 'WeChat'
        }
      ]
    },
    playerReferralLink() {
      const playerId =
        this.$store.state?.player?.player?.player_id || this.$cookie?.get('player')?.player_id
      const referralDomain =
        this.playerInviteAndEarnDomain.domain || this.$cookie.get('referral_domain')
      return referralDomain ? `https://${referralDomain}/u/${playerId}` : ''
    }
  },
  methods: {
    isEqual(obj1, obj2) {
      // repeat the rules to disable the submit btn if any rule fired
      if (obj1 && this.getSocialMediaIdRules && this.getSocialMediaTypeRules) {
        const hasValidationErrors = obj1.social_info?.some((item, index) => {
          const idRules = this.getSocialMediaIdRules(item, index)
          const idValid = idRules.every(rule => rule(item.social_media_id) === true)

          const typeRules = this.getSocialMediaTypeRules(item, index)
          const typeValid = typeRules.every(rule => rule(item.social_media_type) === true)

          return !idValid || !typeValid
        })

        if (hasValidationErrors) {
          return true
        }
      }

      // Original equality check
      if (obj1 === obj2) {
        return true
      }
      if (obj1 == null || obj2 == null) {
        return false
      }
      if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        return false
      }
      const keys1 = Object.keys(obj1)
      const keys2 = Object.keys(obj2)
      if (keys1.length !== keys2.length) {
        return false
      }
      for (const key of keys1) {
        if (!keys2.includes(key)) {
          return false
        }

        if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
          if (!this.isEqual(obj1[key], obj2[key])) {
            return false
          }
        } else if (obj1[key] !== obj2[key]) {
          return false
        }
      }
      return true
    },
    async updateProfile() {
      const isMainFormValid = this.$refs?.refProfile?.validate()
      const socialMediaIds = this.$refs.socialMediaIdField || []
      const socialMediaTypes = this.$refs.socialMediaTypeField || []

      const socialItems = this.formData.social_info
      const isEmptyItem = item => !item.social_media_id && !item.social_media_type

      let isSocialValid = true

      if (socialItems.length === 1) {
        if (isEmptyItem(socialItems[0])) {
          isSocialValid = true
        } else {
          const idValid = socialMediaIds[0]?.validate()
          const typeValid = socialMediaTypes[0]?.validate()
          isSocialValid = idValid && typeValid
        }
      } else {
        const allIdValid = socialMediaIds.map(f => f.validate()).every(valid => valid)
        const allTypeValid = socialMediaTypes.map(f => f.validate()).every(valid => valid)
        isSocialValid = allIdValid && allTypeValid
      }

      const isFormValid = isMainFormValid || isSocialValid

      if(!isFormValid && !isSocialValid){
        this.panel = 1;
      }

      if (isFormValid) {
        // this.formValid) {

        if (!isMainFormValid && isSocialValid) {
          // if social media is not entered
          // but some other fields is entered
          // reset red color
          this.$refs?.refProfile?.resetValidation()
        }

        const cleaned = Object.fromEntries(
          Object.entries(this.formData).filter(([_, value]) => value !== null && value !== '')
        )
        delete cleaned.phone
        const form = {
          ...cleaned
        }

        if (this.isBirthdateAlreadyAdded) delete form.date_of_birth
        await this.$store.dispatch('themes/player/doUpdatePlayerProfile', {
          ...form
        })
      }
    },
    getSocialMediaIdRules(item, index) {
      
      const rules = [
        // ignore for one item but not enter both fields
        v => (!item?.social_media_type && this.formData.social_info?.length === 1) || !!v || this.tr(this.FRONTEND_ERROR_CODES.socialMediaIdIsRequired),
        // Required rule
        v => !item?.social_media_type || !!v || this.tr(this.FRONTEND_ERROR_CODES.socialMediaIdIsRequired),
        // Duplicate check
        v => {
          if (!v) return true
          const isDuplicate = this.formData.social_info.some((otherItem, otherIndex) => {
            if (otherIndex === index) return false // Skip current item
            if (!item?.social_media_type) {
              return false;
            }
            return (
              otherItem?.social_media_id === v &&
              otherItem?.social_media_type === item?.social_media_type
            )
          })
          return !isDuplicate || this.tr(this.FRONTEND_ERROR_CODES.socialMediaIdIsDuplicated)
        }
      ]
      return rules 
    },
    getSocialMediaTypeRules(item, index) {
      const rules = [
        // ignore for one item but not enter both fields
        v => (!item.social_media_id && this.formData.social_info?.length === 1) || !!v || this.tr(this.FRONTEND_ERROR_CODES.platformIsRequired),
          // Required rule
        v => !item.social_media_id || !!v || this.tr(this.FRONTEND_ERROR_CODES.platformIsRequired),
        // Duplicate check
        v => {
          if (!v) return true
          const isDuplicate = this.formData.social_info.some((otherItem, otherIndex) => {
            if (otherIndex === index) return false // Skip current item
            if (!item?.social_media_id) {
              return false;
            }
            return (
              otherItem?.social_media_type === v &&
              otherItem?.social_media_id === item?.social_media_id
            )
          })
          return !isDuplicate || this.tr(this.FRONTEND_ERROR_CODES.platformIsDuplicated)
        }
      ]

      return rules
    },
  },
  watch: {
    'formData.social_info': {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.socialMediaIdField) {
            this.$refs.socialMediaIdField.forEach(field => field.validate())
          }
          if (this.$refs.socialMediaTypeField) {
            this.$refs.socialMediaTypeField.forEach(field => field.validate())
          }
        })
      },
      deep: true
    }
  }
}
